import { BellIcon, ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../contexts/AuthContext';

export function Header() {
  const { user, logout } = useAuth();

  const hora = new Date().getHours();
  const saludo = hora < 12 ? 'Buenos días' : hora < 20 ? 'Buenas tardes' : 'Buenas noches';

  return (
    <header className="hidden lg:flex items-center justify-between h-16 bg-white border-b border-secondary-200 px-8">
      <script dangerouslySetInnerHTML={{__html: `
        let deferredPrompt;
        window.addEventListener('beforeinstallprompt', (e) => {
          e.preventDefault();
          deferredPrompt = e;
          document.getElementById('installBtn')?.classList.remove('hidden');
        });
        function installApp() {
          if (deferredPrompt) {
            deferredPrompt.prompt();
            deferredPrompt.userChoice.then(() => { deferredPrompt = null; document.getElementById('installBtn')?.classList.add('hidden'); });
          }
        }
      `}} />
      <div>
        <h1 className="text-xl font-semibold text-secondary-900">
          {saludo}, {user?.firstName}! 👋
        </h1>
        <p className="text-sm text-secondary-500">
          Aquí tienes el resumen de tu negocio hoy.
        </p>
      </div>

      <div className="flex items-center space-x-3">
        <button id="installBtn" onClick={() => (window as any).installApp?.()} className="hidden items-center gap-2 px-3 py-2 text-sm font-medium text-primary-600 hover:bg-primary-50 rounded-lg transition-colors">
          📱 Instalar app
        </button>
        <button className="relative p-2 text-secondary-400 hover:text-secondary-500 rounded-lg hover:bg-secondary-50 transition-colors">
          <BellIcon className="h-6 w-6" />
          <span className="absolute top-1.5 right-1.5 h-2 w-2 rounded-full bg-red-500"></span>
        </button>
        <div className="h-6 w-px bg-secondary-200"></div>
        <div className="flex items-center gap-3">
          <div className="text-right hidden xl:block">
            <p className="text-sm font-semibold text-secondary-900">{user?.firstName} {user?.lastName}</p>
            <p className="text-xs text-secondary-400">{user?.email}</p>
          </div>
          <button
            onClick={logout}
            className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-secondary-600 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
            title="Cerrar sesión"
          >
            <ArrowRightOnRectangleIcon className="h-5 w-5" />
            <span className="hidden xl:block">Cerrar sesión</span>
          </button>
        </div>
      </div>
    </header>
  );
}
